import React, { useState } from "react"
import { Button, Col, Flex, Form, FormInstance, Input, Row, Tag } from "antd"
import { CloseCircleFilled } from "@ant-design/icons"
import classNames from "classnames"

import { CurrenciesCollection } from "@src/app/CurrenciesCollection"
import { WidgetCard } from "@src/pages/widgetModify/ui/WidgetCard"
import { WidgetCurrencySelect } from "@src/pages/widgetModify/ui/WidgetCurrencySelect"
type Props = {
  currencies: CurrenciesCollection
  form: FormInstance
}
export const WidgetConfigFields = ({ currencies, form }: Props) => {
  return (
    <WidgetCard style={{ width: "100%" }} title="Config fields">
      <Flex gap={16} style={{ width: "100%" }} vertical>
        <Row align="middle" gutter={32}>
          <Col span={12}>
            <Form.Item label="Amount" name="amount">
              <Input placeholder="Enter amount" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Email" name="email">
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col span={12}>
            <WidgetCurrencySelect
              currencies={currencies.crypto}
              form={form}
              label="Currencies"
              name="currencies"
              renderSelected={(selected, { remove }) => {
                return (
                  <Row className={classNames({})} gutter={[16, 16]} wrap>
                    {selected.map((c: string) => {
                      const [symbol, network] = c.split("_")
                      const currency = currencies.crypto.find(
                        (i) => `${i.symbol}_${i.network}` === c,
                      )

                      const displayName = `${currency?.symbol_alias ?? symbol} (${currency?.network ?? network})`
                      const value = `${symbol}_${network}`

                      return (
                        <Col span={12} style={{ height: 80 }}>
                          <Form.Item
                            label={displayName}
                            layout="vertical"
                            name={[`currenciesAddresses`, value]}
                          >
                            <Flex gap={16}>
                              <Input placeholder="Enter address" />
                              <Button
                                icon={<CloseCircleFilled />}
                                onClick={() => remove(c)}
                                type="text"
                              ></Button>
                            </Flex>
                          </Form.Item>
                        </Col>
                      )
                    })}
                  </Row>
                )
              }}
            ></WidgetCurrencySelect>
          </Col>

          <Col span={12}>
            <WidgetCurrencySelect
              currencies={currencies.fiat}
              form={form}
              label="Currencies fiat"
              name="currenciesFiat"
              renderSelected={(list, { remove }) =>
                list.map((c: string) => {
                  const [symbol, network] = c.split("_")
                  const currency = currencies.crypto.find(
                    (i) => `${i.symbol}_${i.network}` === c,
                  )

                  const displayName = `${currency?.symbol_alias ?? symbol} (${currency?.network ?? network})`
                  const value = `${symbol}_${network}`

                  return (
                    <Tag
                      closeIcon={<CloseCircleFilled />}
                      key={c}
                      onClose={() => remove(c)}
                    >
                      {displayName}
                    </Tag>
                  )
                })
              }
            ></WidgetCurrencySelect>
          </Col>
        </Row>
      </Flex>
    </WidgetCard>
  )
}
